import { useState } from "react";
import { PageHeader } from "../components/Common";
import { Button } from "../components/ui/button";
import { LinksDirectory } from "../components/links/LinksDirectory";

export default function ImportantLinksPage() {
  const [manage, setManage] = useState(false);
  return (
    <div className="space-y-6">
      <PageHeader overline="Resources" title="Important Links" desc="Search your organisation's approved resources and keep your own private links. Links open in a new tab.">
        <Button variant={manage ? "default" : "secondary"} onClick={() => setManage((m) => !m)} data-testid="links-manage-toggle">{manage ? "Done managing" : "Manage links"}</Button>
      </PageHeader>
      <LinksDirectory manage={manage} />
    </div>
  );
}
